import { SapOdpCopySourceAdapter } from 'app/model/adapters/activities/copysource/sap-odp.copysource.adapter';
import { AdapterRegistry, IModel, Metamodel } from 'shell-models-lib';
import { commonCopySourceAdapts } from 'app/model/adapters/activities/copysource/copysource.adapter';
import { SapCdcCopySource } from 'app/model/pipeline/copysource/sap-cdc.copysource';

/**
 * @deprecated
 */
@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapCdcCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        extractionMode: '*',
        subscriberProcess: '*',
        projection: '*',
        selection: '*'
    }
})
export class SapCdcCopySourceAdapter extends SapOdpCopySourceAdapter {
    protected model(): IModel {
        return SapCdcCopySource.MODEL;
    }
}
